import i18n from "i18next";
import React from "react";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import esCommonLocale from "./locales/es/common.json";
import enCommonLocale from "./locales/en/common.json";

import esTemplateCatalogLocale from "./locales/es/template-catalog.json";
import enTemplateCatalogLocale from "./locales/en/template-catalog.json";
import esNewEditor from "./locales/es/newEditor.json";
import enNewEditor from "./locales/en/newEditor.json";
const resources = {
  es: {
    common: esCommonLocale,
    "template-catalog": esTemplateCatalogLocale,
    newEditor: esNewEditor,
  },
  en: {
    common: enCommonLocale,
    "template-catalog": enTemplateCatalogLocale,
    newEditor: enNewEditor,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    // lng: "en",
    defaultNS: "common",
    fallbackLng: "en",
    debug: false,
    keySeparator: ".",

    interpolation: {
      escapeValue: false,
      format: function (value, format, lng) {
        if (format === "uppercase") return value.toUpperCase();
        if (format === "bold") return <strong>{value}</strong>;
        return value;
      },
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
